export function toggleSubMenuSubMenu() {
    const btnReturnMenu = document.querySelector("[data-action='return-submenu']")
    if (document.querySelector("body").classList.contains("mobile")) {
        btnReturnMenu.classList.add("hidden")
    }
}
